<template>
    <div class="df-outer">
      <DesktopSearchBar />
    </div>
</template>

<script setup lang="ts">
import DesktopSearchBar from "@/vue/planning/components/search/DesktopSearchBar.vue";
import { useStore } from 'vuex'
const store = useStore()

</script>

<style scoped>
.df-outer {
  color: gray;
  margin: 10px 15px;
  padding: 10px 15px;
  border-radius: 56px;
  border: 1px solid var(--grey-grey-300, #dee2e6);
  background: var(--white, #fff);
  box-shadow: 0px 1px 8px 0px rgba(16, 24, 40, 0.1), 0px 1px 3px 0px rgba(16, 24, 40, 0.1);
  height: 74px;
  cursor: pointer;
}
</style>
